import React, { useState } from "react";

const ActiveRoomContext = React.createContext();
const ActiveRoomContextSetState = React.createContext();

function ActiveRoomProvider({ children }) {
  const [activeRoom, setCurrentRoom] = useState("");
  return (
    <ActiveRoomContext.Provider value={activeRoom}>
      <ActiveRoomContextSetState.Provider value={setCurrentRoom}>
        {children}
      </ActiveRoomContextSetState.Provider>
    </ActiveRoomContext.Provider>
  );
}

function useActiveRoomState() {
  return React.useContext(ActiveRoomContext);
}

function useActiveRoomSetState() {
  return React.useContext(ActiveRoomContextSetState);
}

function useActiveRoomActions(item) {
  const updateActiveRoom = useActiveRoomSetState();
  const setCurrentRoom = (item) => {
    updateActiveRoom(item);
  };
  return { setCurrentRoom };
}

export { useActiveRoomState, useActiveRoomSetState, useActiveRoomActions };
export default ActiveRoomProvider;
